import { defineRecipe } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  variants: {
    variant: {
      plain: {
        cursor: 'pointer',
        _focus: {
          outline: 'none',
        },
        _hover: {
          textDecor: 'none',
        },
      },
    },
  },
});
